import i18n from '@/lang'

const forbiddenFont = {
  namespaced: true,

  state: {
    forbiddenFontDialog: {
      visible: false,
      loading: false,
      forbiddenFontList: {},
      fontOptions: [],
      message: i18n.t('playTurbo.common.fontForbidden.msgDialog'),
      assetFontConfig: { list: false },
    },
  },

  mutations: {
    updateForbiddenFontDialog(state, data) {
      Object.assign(state.forbiddenFontDialog, data)
    },
  },
}

export default forbiddenFont
